import url from './url';

async function getAulasByModulo(token, cd_modulo) {

    let data = await fetch(`${url}/aula/modulo/${cd_modulo}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function showAula(token, cd_aula) {

    let data = await fetch(`${url}/aula/${cd_aula}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function getMateriaisAula(token, cd_aula) {

    let data = await fetch(`${url}/download/aula/${cd_aula}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { getAulasByModulo, showAula, getMateriaisAula }